// src/utils/chartSetup.js
import {
    Chart as ChartJS,
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
  } from 'chart.js';
  
  ChartJS.register(
    ArcElement,        // for Pie chart
    BarElement,        // for Bar chart
    CategoryScale,     // x-axis for Bar chart
    LinearScale,       // y-axis for Bar chart
    Tooltip,
    Legend,
    Title
  );
  